module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "blue-grey--text",
    attrs: {
      "color": "blue-grey lighten-5",
      "app": ""
    }
  }, [_c('span', {
    staticClass: "subheading",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v(" © 2018 Iobio.io")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "http://iobio.io/blog.html",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue-grey darken-1",
      "flat": "",
      "round": ""
    }
  }, [_vm._v("\n          Blog\n      ")])], 1)]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "http://iobio.io/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue-grey darken-1",
      "flat": "",
      "round": ""
    }
  }, [_vm._v("\n          iobio\n      ")])], 1)]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "http://marthlab.org/",
      "target": "_blank"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue-grey darken-1",
      "flat": "",
      "round": ""
    }
  }, [_vm._v("\n          MarthLab\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e15fa33","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/app/components/partials/Footer.vue
// module id = 496
// module chunks = 0